export default "__VITE_ASSET__BA6b3psw__"